export class SettingsController {
    send;
    current;
    constructor(send) {
        this.send = send;
    }
    set(settings) {
        this.current = { ...settings };
        this.send(this.current);
    }
    resend() {
        if (this.current)
            this.send(this.current);
    }
}
//# sourceMappingURL=settings.js.map